import Base from 'base/control/dropdown'
import { default as User } from './User'
import { default as Gender } from './Gender'

export default {
  Base,
  User,
  Gender,
}
